"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (data) { return Math.min.apply(Math, data); });
//# sourceMappingURL=min.js.map